import React, { useContext } from "react";
import OnColorContext from "../../../../contexts/OnColorContext";
import FlexItemOrg from "../../../organisms/FlexItemOrg";
import PushOrg from "../../../organisms/PushOrg";
import { ItemsBox, PromotionText, RenewalPrice, StyledHorizontalProductBoxMol } from "./DesktopProductBoxMol.styled";
function DesktopProductBoxMol(_ref) {
  var items = _ref.items,
    promotionText = _ref.promotionText,
    renewalPrice = _ref.renewalPrice;
  var onColor = useContext(OnColorContext);
  var bottomSpace = renewalPrice ? 4 : 0.5;
  return /*#__PURE__*/React.createElement(StyledHorizontalProductBoxMol, {
    $hasPromotionText: !!promotionText,
    $onColor: onColor
  }, promotionText ? /*#__PURE__*/React.createElement(PromotionText, {
    typography: "buttonSmall",
    color: "white"
  }, promotionText) : null, /*#__PURE__*/React.createElement(ItemsBox, {
    alignItems: "center",
    gapSpace: 4
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(FlexItemOrg, {
      key: item.title,
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: "".concat(item.widthPercent, "%")
    }, /*#__PURE__*/React.createElement(PushOrg, {
      bottomSpace: index === items.length - 1 ? bottomSpace : undefined,
      hasNoReset: true
    }, item.text));
  })), renewalPrice ? /*#__PURE__*/React.createElement(RenewalPrice, null, renewalPrice) : undefined);
}
export default DesktopProductBoxMol;